import { render, staticRenderFns } from "./SelectItems.vue?vue&type=template&id=fa554f50&scoped=true"
import script from "./SelectItems.vue?vue&type=script&lang=js"
export * from "./SelectItems.vue?vue&type=script&lang=js"
import style0 from "./SelectItems.vue?vue&type=style&index=0&id=fa554f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa554f50",
  null
  
)

export default component.exports